<template>
  <div class="centervideo">
    <!-- <div class="headersts">
      <img src="../../../../assets/images/home/logo.png" class="imgsts" alt @click="retrungo()" />
      <span style="cursor: pointer;margin-left:5px" @click="retrungo()">学堂科技教育训练网络学院</span>
    </div>-->
    <vsmallheader></vsmallheader>

    <div class="centerheader">
      <div class="centerheaderul">
        <label>课件</label>
        <p class="arrowspd">></p>

        <select
          name="public-choice"
          class="selcetbox"
          v-model="parentIdOne"
          @change="getCouponSelected"
        >
          <option :value="item.id" v-for="(item,index) in mooklist" :key="index">{{item.name}}</option>
        </select>

        <p class="arrowspd">></p>
        <select
          name="public-choice"
          v-model="catalogueIdOne"
          class="selcetbox"
          @change="getCouponSelectedtwo"
        >
          <option :value="item.id" v-for="(item,index) in mooklistTwo" :key="index">{{item.name}}</option>
        </select>
      </div>
    </div>
    <div class="chape-right">
      <div class="hedvidebox">
        <li
          :class="{'current':isActive==index}"
          style="flex: 1;display: flex;justify-content: center;align-items: center;"
          v-for="(item,index) in catalist"
          :key="index"
          @click="btnvide_txt(item,index)"
        >
          <img v-if="item.type==1" src="@/assets/videoimg/studyVideo.svg" />
          <img v-if="item.type==2" src="@/assets/videoimg/studydocument.svg" />
          <img v-if="item.type==3" src="@/assets/videoimg/studyexercise.svg" />
        </li>
      </div>

      <div class="tabx" v-if="type==1 || type==2" ref="tabx1">
        <div class="chape-right-center" v-if="type==1">
          <div class="veo-display-show" v-if="displayShow">
            <div class="veo-display">
              <slide-verify
                ref="slideblock"
                @success="onSuccess"
                @again="onAgain"
                @fulfilled="onFulfilled"
                @fail="onFail"
                @refresh="onRefresh"
                :slider-text="text"
                :imgs="imgs"
              ></slide-verify>
              <!-- :accuracy="accuracy" -->
              <div class="sidletext">{{ msg }}</div>
            </div>
          </div>

          <div style="width:100%;height:100%">
            <video-player
              :class="['vjs-custom-skin']"
              style="object-fit: cover"
              ref="videoPlayer"
              :fluid="true"
              :options="playerOptions"
              :playsinline="false"
              :fullSreen="true"
              @play="onPlayerPlay($event)"
              @pause="onPlayerPause($event)"
              @ended="onPlayerEnded($event)"
              @timeupdate="onPlayerTimeupdate($event)"
            ></video-player>
          </div>
          <vue-baberrage
            :isShow="barrageIsShow"
            :boxWidth="1200"
            :barrageList="barrageList"
            :loop="barrageLoop"
            style="position: absolute; top: 0;left: 0;height:200px"
          ></vue-baberrage>
          <div class="next-box" v-show="visShow == 1">
            <div>
              <div class="nexpalys">即将为你打开下一个学习视频</div>
              <div class="circleclas">{{countdown}}</div>
              <div class="replayclas" @click="replay">重新播放</div>

              <!-- <el-button type="success" round v-if="accomplishflg==false" @click="replay">重新播放</el-button> -->
              <!-- <div v-if="accomplishflg==true">当前视频已看完！</div> -->
            </div>
          </div>
          <div class="Tips" v-show="visShow == 5">
            <span>为保证学习质量，第一次观看无法快进！</span>
            <el-button type="success" round @click="speedclick">确定</el-button>
          </div>
        </div>
        <pdflist v-if="type==2" :payurl="payurl"></pdflist>
      </div>

      <div class="tabx" v-if="type==3" style="overflow: hidden;overflow-y: auto;">
        <examinationlist v-if="type==3" :guelistCommon="guelistCommon"></examinationlist>
      </div>
    </div>

    <div class="fottervide">
      <div class="chape-right-footer">
        <div class="browse-left">
          <!-- <div class="browsebox" @click="palyerVideoAdtext()">
            <img class="browse-img" src="@/assets/videoimg/studyVideo.svg" />
            <span class="browse-text">12</span>
          </div>
          <div class="browsebox" @click="palyerVideoAdtext()">
            <img class="browse-img" src="@/assets/videoimg/studyVideo.svg" />
            <span class="browse-text">30</span>
          </div>-->
        </div>
        <div class="browse-right">
          <div
            class="browsebox biji"
            style="color:#fff;cursor: pointer;padding: 10px;"
            @click="makebook"
          >做笔记</div>
          <div class="browsebox" @click="tailgive()">
            <img src="@/assets/videoimg/givevvv.svg" class="browse-img" alt v-if="isGive==false" />
            <img src="@/assets/videoimg/giveActive.svg" class="browse-img" alt v-else />
            <span class="browse-text">点赞</span>
          </div>
          <div class="browsebox" @click="tailcollect()">
            <img
              src="@/assets/videoimg/colleVideo.svg"
              alt
              class="browse-img"
              v-if="collectflag==false"
            />
            <img src="@/assets/videoimg/collectActive.svg" class="browse-img" alt v-else />
            <span class="browse-text">收藏</span>
          </div>
        </div>
      </div>
    </div>

    <div class="withreview">
      <el-form
        :model="reviewForm"
        :rules="bookrules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <div style="display:flex;justify-content: space-between;"></div>
        <!-- <div style="display:flex;justify-content: space-between;">
          <el-form-item prop="message" style="margin-top:8px;flex:4">
            <el-input
              type="textarea"
              v-model="reviewForm.message"
              ref="message"
              placeholder="请对课程内容发表你的评论吧！"
              :maxlength="100"
            ></el-input>
          </el-form-item>
          <el-form-item style="text-align:center;flex:1;padding-top:8px">
            <el-button type="primary" style="height:50px" @click="publishCommen('ruleForm')">发表评论</el-button>
          </el-form-item>
        </div>-->

        <div style="display:flex;justify-content: space-between;">
          <el-form-item prop="message" style="flex:4">
            <el-input
              type="textarea"
              v-model="reviewForm.message"
              ref="message"
              placeholder="请对资源内容发表你的评论吧！"
              :maxlength="100"
            ></el-input>
          </el-form-item>

          <div class="btnsmint" @click="publishCommen('ruleForm')">
            <div>
              <div>发表</div>
              <div>评论</div>
            </div>
          </div>
        </div>
      </el-form>
    </div>
    <!-- <div style="display:flex;align-items: center;width:1200px;margin:0 auto">
      <div class="display:flex;align-items: center">
        <el-input type="text" style="width:250px" placeholder="请输入弹幕" v-model="msgTitle"></el-input>
        <el-button type="success" @click="addToList" style="margin-left:10px">确定</el-button>
      </div>
    </div>-->

    <!-- 底部 -->
    <div v-if="MoocTalkLoadlist.length!==0">
      <div class="introducel">
        <div class="gaishu" v-for="(item,index) in MoocTalkLoadlist" :key="index">
          <img class="gaiimg" :src="item.photo" />
          <div class="gaisuflex">
            <div class="gaisuname">{{item.createName}}</div>
            <div class="gaisutext">{{item.message}}</div>
            <div class="giveclbox">
              <!-- <div class="givecl">
                <img src="@/assets/sppt/2.jpg" />
                点赞
              </div>-->
              <div></div>
              <span class="give-time">{{item.createTime}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <nodata></nodata>
    </div>

    <div class="pageblock">
      <el-pagination
        background
        prev-text="上一页"
        next-text="下一页"
        layout="total,prev, pager, next,jumper"
        :page-size="pageSize"
        :current-page.sync="pageIndex"
        :total="countlist"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        v-if="countlist>0"
      ></el-pagination>
    </div>

    <el-dialog
      :close-on-click-modal="false"
      title="创建笔记"
      :visible.sync="dialogVisibleBook"
      width="40%"
    >
      <el-form
        :rules="rules"
        ref="bookData"
        label-position="right"
        label-width="100px"
        :model="bookData"
      >
        <div style="margin-left:100px;margin-top:10px">
          <!-- <el-form-item label="标题" prop="title">
            <el-input v-model="bookData.title" style="width:400px"></el-input>
          </el-form-item>

          <el-form-item label="描述" prop="descript">
            <el-input v-model="bookData.descript" style="width:400px"></el-input>
          </el-form-item>-->

          <!-- <el-form-item label="内容" prop="contents">
            <editors
              ref="editor"
              v-model="bookData.contents"
              :catchData="con"
              :isClear="true"
              v-if="dialogVisibleEduca"
              style="width:800px"
            ></editors>
          </el-form-item>-->

          <div>
            <img :src="previewImg" style="width:85%;height:85%" alt />
          </div>
          <!-- <div style="text-align: center;">
            <el-button type="primary" @click="addOrEduca">提交</el-button>
          </div>-->
        </div>
      </el-form>
    </el-dialog>
    <el-dialog
      width="500px"
      class="dialog-mini"
      v-el-drag-dialog
      title="准入考试"
      :visible.sync="innerVisible"
      append-to-body
    >
      <div class="learnClass">
        <img src="@/assets/personCenter/u4255.png" />
        <span style="font-size: 16px;">您已完成本次培训班的所有课前预习，是否立即参加准入考试？</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="innerVisible = false">立即考试</el-button>
        <el-button type="info" size="mini" @click="innerVisible = false">暂不考试</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import vsmallheader from '@/views/smallHeader/index';
import swiperlist from './components/swiperlist/index';
import pdflist from './components/pdflist/index';
import examinationlist from './components/examinationlist/index';

import * as studyClassIndex from '@/api/studyClass/index';
import * as publicGive from '@/api/public';
import Vue from 'vue';
import { vueBaberrage } from 'vue-baberrage';
Vue.use(vueBaberrage);
import { MESSAGE_TYPE } from 'vue-baberrage';

import html2Canvas from 'html2canvas';
import VideoPlayer from 'vue-video-player';
window.videojs = VideoPlayer.videojs;
require('video.js/dist/lang/zh-CN.js');
require('video.js/dist/video-js.css');
require('vue-video-player/src/custom-theme.css');
import 'videojs-flash'; //引入才能播放rtmp视屏
import 'videojs-contrib-hls'; //引入才能播放m3u8文件
import img0 from '@/assets/zhezhao/img.jpg';
import img1 from '@/assets/zhezhao/img1.jpg';
import img2 from '@/assets/zhezhao/img2.jpg';
import img3 from '@/assets/zhezhao/img3.jpg';
import img4 from '@/assets/zhezhao/img4.jpg';
import img5 from '@/assets/zhezhao/img5.jpg';
Vue.use(VideoPlayer);
import elDragDialog from '@/directive/el-dragDialog';

export default {
  components: { swiperlist, pdflist, examinationlist, vsmallheader },
  directives: {
    elDragDialog,
  },
  data() {
    return {
      msgTitle: '',
      barrageIsShow: true,
      currentId: 0,
      barrageLoop: false,
      barrageList: [],

      dialogVisibleBook: false,
      accuracy: 3,
      displayShow: false,
      msg: '',
      text: '向右滑动->',
      imgs: [img0, img1, img2, img3, img4, img5],
      reviewForm: {
        courseId: this.$route.query.id,
        catalogueId: this.$route.query.catalogueId,
        resourcetId: 0,
        message: '',
        createId: this.$store.state.User.ids,
      },
      rules: {
        message: { required: true, message: '请输入您的评论', trigger: 'blur' },
      },
      bookData: {},
      bookrules: {},
      giveflag: '',
      collectflag: '',
      gklog: 0,
      sucontlist: '',
      countdown: 5,
      timer: null,
      pageIndex: 1,
      pageSize: 10,
      countlist: 0,
      accomplishflg: false,
      isGive: Boolean,
      payurl: '',
      txtVal: 0,
      desc: '',
      Selectedtwo: 0,
      parentIdOne: 0,
      catalogueIdOne: 0,
      id: this.$route.query.id,
      sourcenIdOne: this.$route.query.sourcenIdOne,
      catalogueId: this.$route.query.catalogueId,
      sourceId: this.$route.query.sourceId,
      trainId: this.$route.query.trainId,
      MoocTalkLoadlist: [],
      activeName: 'second',
      type: 0,
      playerOptions: {
        objectFit: 'contain',
        height: '540px',
        size: '100%',
        autoplay: false,
        muted: false,
        language: 'en',
        webkitPlaysinline: 'true',
        language: 'zh-CN',
        playbackRates: [0.5, 1.0, 1.5, 2.0],
        videoComplete: false,
        sources: [
          {
            src: '',
          },
        ],
        // /uploadfile/2021/05/11/2021051114400955.mp4
        // http://121.12.125.214:8082/uploadfile/2021/05/11/2021051114400955.mp4
        // http://szrdpxcloud.com:82/videos/course/2020/12/30/b55efe1c-1ae4-4cca-a947-7bd02fd532e4/index.m3u8
        presentTiem: '',
        videoStepId: '',
      },
      previewImg: '',
      visShow: 0,
      isActive: 0,
      mooklist: [],
      mooklistTwo: [],
      catalist: [],
      guelist: '',
      guelistCommon: [],
      nextVideoAdress: '',
      nextVideoId: '',
      mark: 0,
      timeCurent: 0,
      timeIndex: 0,
      PlayTime: 0,

      video_real_time: 0,
      initial_time: 0,
      aa: 0,
      timeList: [
        {
          Juge: false,
          Times: 10,
        },
        {
          Juge: false,
          Times: 30,
        },
        {
          Juge: false,
          Times: 50,
        },
        {
          Juge: false,
          Times: 70,
        },
      ],
      innerVisible: false,
    };
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    },
  },
  mounted() {
    this.getrecentlyPlayedvideos(); //播放记录
    this.getstickingPointTime();
    this.getMooklist();
    this.AssistIsAssist(); //查询当前是否点赞
    this.whethercollect();
  },
  methods: {
    addToList() {
      let list = [
        {
          id: 1,
          msg: '湖人总冠军',
          time: 1,
          barrageStyle: 'yibai',
        },
        {
          id: 2,
          msg: '第二条弹幕',
          time: 2,
          barrageStyle: 'erbai',
        },
        {
          id: 3,
          msg: '第三条弹幕',
          time: 3,
          barrageStyle: 'sanbai',
        },
        {
          id: 4,
          msg: '第四条弹幕',
          time: 4,
          barrageStyle: 'sibai',
        },
      ];

      // this.barrageList.push({
      //   id: ++this.currentId,
      //   msg: this.msgTitle,
      //   time: 5,
      //   type: MESSAGE_TYPE.NORMAL,
      // });

      list.forEach((v) => {
        this.barrageList.push({
          id: v.id, //弹幕ID
          msg: v.msg, //弹幕消息
          time: v.time, //屏幕展示时间
          type: MESSAGE_TYPE.NORMAL, //类型
          barrageStyle: v.barrageStyle, //自定义样式
        });
      });
    },
    makebook() {
      this.dialogVisibleBook = true;
      this.getVideoPic();
      // this.hcanvas()
    },
    getVideoPic() {
      let video = document.getElementsByClassName('vjs-tech')[0];
      let canvas = document.createElement('canvas');
      let w = 1200;
      let h = 540;
      canvas.width = w;
      canvas.height = h;
      console.log(canvas);
      const ctx = canvas.getContext('2d');
      ctx.drawImage(video, 0, 0, w, h);
      // ctx.drawImage(video, 0, 0, w, h);
      this.previewImg = canvas.toDataURL('image/png');

      // console.log(this.previewImg.substr(22));
      // let formData = new FormData();
      //       formData.append('publicFile', this.previewImg ); // 文件对象
      //       formData.append('fileName', '123.png' );
      // publicGive.uploadDoc(formData).then((res) => {

      // });
    },
    hcanvas() {
      let _this = this;
      html2Canvas(this.$refs.tabx1, { useCORS: true }).then(function (canvas) {
        var url = canvas.toBlob(function (blob) {
          // console.log(blob);
          let formData = new FormData();
          formData.append('publicFile', blob); // 文件对象
          formData.append('fileName', '123.png');
          publicGive.uploadDoc(formData).then((res) => {});
        });
      });
    },
    retrungo() {
      this.$router.push('/home');
    },
    //判断是否收藏
    whethercollect() {
      let para = {
        objId: this.sourceId,
        objType: 10,
        userId: this.$store.state.User.ids * 1,
      };
      publicGive.CollectionIsColl(para).then((res) => {
        this.collectflag = res.result;
      });
    },
    // 收藏
    tailcollect() {
      if (this.collectflag == false) {
        //添加收藏
        let para = {
          objType: 10,
          objId: this.sourceId,
          createId: this.$store.state.User.ids * 1,
        };
        publicGive.CollectionAdd(para).then((res) => {
          this.$message({
            message: '收藏成功',
            type: 'success',
          });
          this.whethercollect();
        });
      } else {
        //取消收藏
        let para = {
          objType: 10,
          objId: this.sourceId,
          userId: this.$store.state.User.ids * 1,
        };
        publicGive.CollectionDele(para).then((res) => {
          this.whethercollect();
          this.$message({
            message: '取消收藏成功',
            type: 'success',
          });
        });
      }
    },
    // 点赞
    tailgive() {
      console.log(this.isGive);
      if (this.isGive == true) {
        this.AssistDelete();
      } else {
        this.taillkGive();
      }
    },
    // 添加点赞
    taillkGive() {
      let _this = this;
      let data = {
        objType: 10,
        objId: this.sourceId,
        createId: this.$store.state.User.ids * 1,
      };
      publicGive.AssistAdd(data).then((res) => {
        // console.log(res);
        this.$message({
          type: 'success',
          message: '成功!',
        });
        // this.isGive = true;
        this.AssistIsAssist();
      });
    },
    // 查询当前是否点赞
    AssistIsAssist() {
      let _this = this;
      let data = {
        objType: 10,
        objId: this.sourceId,
        userId: this.$store.state.User.ids * 1,
        // userId
      };
      publicGive.AssistIsAssist(data).then((res) => {
        // console.log(res);
        this.isGive = res.result;
      });
    },
    // 取消点赞
    AssistDelete() {
      let _this = this;
      let data = {
        objType: 10,
        objId: this.sourceId,
        userId: this.$store.state.User.ids * 1,
      };
      publicGive.AssistDelete(data).then((res) => {
        console.log(res);
        this.$message({
          type: 'success',
          message: '取消成功!',
        });
        // this.isGive = false;
        this.AssistIsAssist();
      });
    },
    // 提交评论
    publishCommen(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // let data = {
          //   courseId: this.id,
          //   catalogueId: this.catalogueIdOne,
          //   resourcetId: 0,
          //   message: this.desc,
          //   createId: this.$store.state.User.ids,
          // };

          studyClassIndex.MoocTalkAdd(this.reviewForm).then((res) => {
            // console.log(res);
            if (res.code == 200) {
              this.$message.success('发表成功！');
            }
            this.desc = '';
            this.Assistload();
          });
        }
      });
    },
    // 查询评论列表
    Assistload() {
      let data = {
        courseId: this.id,
        catalogueId: this.catalogueIdOne,
        page: this.pageIndex,
        limit: this.pageSize,
      };
      studyClassIndex.MoocTalkLoad(data).then((res) => {
        // console.log(res);
        this.MoocTalkLoadlist = res.data;
        this.countlist = res.count;
      });
    },

    // 获取课程资源列表
    getMooklist() {
      let _this = this;
      let data = { courseId: _this.id, parentId: 0 };
      studyClassIndex.MoocGetListByPid(data).then((res) => {
        // console.log(res.result);
        let list = res.result;
        for (let i = 0; i < list.length; i++) {
          if (list[i].id == _this.sourcenIdOne) {
            _this.parentIdOne = list[i].id;
          }
        }
        _this.mooklist = res.result;
        _this.getMooklistTwo();
      });
    },
    // 根据父节点查询
    getMooklistTwo() {
      let _this = this;
      let data = { courseId: _this.id, parentId: _this.parentIdOne };
      studyClassIndex.MoocGetListByPid(data).then((res) => {
        // console.log(res.result);
        let list = res.result;

        for (let i = 0; i < list.length; i++) {
          if (list[i].id == _this.catalogueId) {
            _this.catalogueIdOne = list[i].id;
          }
        }
        _this.mooklistTwo = res.result;
        _this.catalogueIdlist();
      });
    },
    // 查询练习题课件
    catalogueIdlist() {
      let _this = this;
      let data = {
        catalogueId: _this.catalogueIdOne,
        page: _this.pageIndex,
        limit: _this.pageSize,
      };
      studyClassIndex.catalogueId(data).then((res) => {
        // console.log(res.data);
        // console.log('查询课件');
        if (res.data.length != 0) {
          let obj = {};
          obj = {
            type: 3,
            filePath: res.data,
            id: 0,
          };

          _this.guelist = obj;
        } else {
          _this.guelist = '';
        }
        _this.GetCatalogue();
      });
    },
    // 查询课件节点下资源
    GetCatalogue() {
      let _this = this;
      let data = { catalogueId: _this.catalogueIdOne };
      studyClassIndex.GetCatalogue(data).then((res) => {
        let list = res.result;
        // console.log(list);
        if (_this.guelist != '') {
          list.push(_this.guelist);
        }
        _this.catalist = list;
        // let sum=-1
        for (let i = 0; i < list.length; i++) {
          if (list[i].id == _this.sourceId) {
            _this.btnvide_txt(list[i], i);
          }
        }

        // console.log(res.result);
      });
    },

    // 提交评论
    publishCommen(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // let data = {
          //   courseId: this.id,
          //   catalogueId: this.catalogueIdOne,
          //   resourcetId: 0,
          //   message: this.desc,
          //   createId: this.$store.state.User.ids,
          // };
          console.log(this.reviewForm);
          studyClassIndex.MoocTalkAdd(this.reviewForm).then((res) => {
            // console.log(res);
            if (res.code == 200) {
              this.$message.success('发表成功！');
            }
            this.reviewForm.message = '';
            this.Assistload();
          });
        }
      });
    },
    // 查询评论列表
    Assistload() {
      let data = {
        courseId: this.id,
        catalogueId: this.catalogueIdOne,
        page: this.pageIndex,
        limit: this.pageSize,
      };
      studyClassIndex.MoocTalkLoad(data).then((res) => {
        // console.log(res);
        this.MoocTalkLoadlist = res.data;
        this.countlist = res.count;
      });
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.Assistload();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.Assistload();
    },
    // 文本计数器
    descInput() {
      this.txtVal = this.desc.length;
    },
    // 添加播放记录
    addCourserecord(isOver) {
      let videoTiem = Number(this.gklog); //播放时长
      // let PlayTimeReood = Number(that.data.PlayTimeReood); //上次播放记录的事件

      // if (that.data.tieml == 1) {
      //   videoTiem = videoTiem;
      //   // console.log('点击播放')
      // } else {
      //   if (Number(PlayTimeReood) > videoTiem) {
      //     videoTiem = PlayTimeReood;
      //     // console.log('上一次播放记录')
      //   }
      // }

      let data = {
        userId: Number(this.$store.state.User.ids),
        trainId: this.$route.query.trainId ? this.$route.query.trainId : 0,
        courseId: Number(this.id), //课程id
        cataId: Number(this.sourcenIdOne), //目录
        subCataId: Number(this.catalogueId),
        resourceId: Number(this.sourceId), //资源
        fileType: this.type, //类型
        isOver: isOver,
      };
      if (this.type == 1) {
        data.learnTime = Math.floor(this.gklog);
        data.playTime = Math.floor(this.gklog);
      }

      console.log(data);
      studyClassIndex.CourseRecordAdd(data).then((res) => {
        console.log(res);
      });
    },

    // 查询播放记录
    getrecentlyPlayedvideos() {
      let data = { page: this.page, limit: this.limit, courseId: this.id };
      studyClassIndex.CourseRecordLoad(data).then((res) => {
        console.log(res);
        console.log('播放记录');
      });
    },
    // 点击大节点查询
    getCouponSelected() {
      let _this = this;
      let data = { courseId: _this.id, parentId: _this.parentIdOne };
      studyClassIndex.MoocGetListByPid(data).then((res) => {
        _this.mooklistTwo = res.result;
        _this.catalogueIdOne = res.result[0].id;
        let datalx = {
          catalogueId: _this.catalogueIdOne,
          page: _this.pageIndex,
          limit: _this.pageSize,
        };
        studyClassIndex.catalogueId(datalx).then((res) => {
          // console.log(res.data);
          if (res.data.length != 0) {
            let obj = {};
            obj = {
              type: 3,
              filePath: res.data,
              id: 99,
            };
            _this.guelist = obj;
          } else {
            _this.guelist = '';
          }
          // 查询当前选中下面的资源
          let datas = { catalogueId: _this.catalogueIdOne };
          studyClassIndex.GetCatalogue(datas).then((res) => {
            let list = res.result[0];
            let listArry = res.result;
            if (listArry.length != 0) {
              if (_this.guelist != '') {
                listArry.push(_this.guelist);
              }
              _this.catalist = listArry;

              _this.btnvide_txt(list, 0);
            }
          });
        });
      });
    },

    // 点击第二节点
    getCouponSelectedtwo() {
      let _this = this;
      // 查询当前下面有没有练习题
      let datalx = {
        catalogueId: _this.catalogueIdOne,
        page: _this.pageIndex,
        limit: _this.pageSize,
      };
      studyClassIndex.catalogueId(datalx).then((res) => {
        // console.log(res.data);
        if (res.data.length != 0) {
          let obj = {};
          obj = {
            type: 3,
            filePath: res.data,
            id: 0,
          };
          _this.guelist = obj;
        } else {
          _this.guelist = '';
        }
        // 查询当前选中下面的资源
        let datas = { catalogueId: _this.catalogueIdOne };
        studyClassIndex.GetCatalogue(datas).then((res) => {
          let list = res.result[0];
          let listArry = res.result;
          if (listArry.length != 0) {
            if (_this.guelist != '') {
              listArry.push(_this.guelist);
            }
            _this.catalist = listArry;

            _this.btnvide_txt(list, 0);
          }
        });
      });
    },
    // 设置路由参数
    setPath() {
      let _this = this;
      const newUrl =
        this.$route.path +
        `?id=${_this.id}&sourcenIdOne=${_this.parentIdOne}&catalogueId=${_this.catalogueIdOne}&sourceId=${_this.sourceId}`;
      window.history.replaceState('', '', newUrl);
      console.log(
        _this.id,
        _this.parentIdOne,
        _this.catalogueIdOne,
        _this.sourceId
      );
    },
    // 点击资源
    palyerVideoAdtext() {},

    // 点击播放资源
    btnvide_txt(sucont, index) {
      let _this = this;
      _this.visShow = 0;
      _this.isActive = index;
      _this.sucontlist = sucont; //当前播放的资源数据
      _this.sourceId = sucont.id; //资源id赋值浏览器
      _this.AssistIsAssist(); //查询当前资源是否点赞
      _this.Assistload(); //查询评论列表
      // console.log(sucont);
      // console.log('点击数据');
      _this.setPath(); //改变浏览器的参数值
      if (sucont.type == 1) {
        _this.type = 1;
        console.log(sucont.filePath);
        _this.playCommon(sucont.filePath);
      } else if (sucont.type == 2) {
        _this.displayShow = false; //关闭暂停弹窗
        _this.payurl = sucont.filePath;
        _this.type = 2;
        _this.addCourserecord(true);
      } else if (sucont.type == 3) {
        _this.displayShow = false; //关闭暂停弹窗
        _this.guelistCommon = sucont.filePath;
        _this.type = 3;
      } else if (sucont.type == 4) {
        _this.displayShow = false; //关闭暂停弹窗
        _this.type = 4;
      } else if (sucont.type == 5) {
        _this.displayShow = false; //关闭暂停弹窗
        _this.type = 5;
      }
    },
    // 播放公用
    playCommon(adressSum) {
      let _this = this;
      this.$nextTick(() => {
        console.log(_this.$refs['videoPlayer']);
        _this.playerOptions.sources[0].src = adressSum;
        _this.$refs['videoPlayer'].options.autoplay = true;
        _this.$refs['videoPlayer'].player.play();
      });
    },
    // 重新播放
    replay() {
      let _this = this;
      _this.visShow = 0;
      console.log(_this.sucontlist.filePath);
      _this.playerOptions.sources[0].src = _this.sucontlist.filePath;
      _this.$refs.videoPlayer.options.autoplay = true;
      _this.$refs.videoPlayer.player.play();
    },
    // 拖动弹窗的功能、-----------------
    onSuccess(times) {
      let _this = this;
      _this.msg = `验证通过, 耗时${(times / 1000).toFixed(1)}s`;
      let time = null;
      time = setTimeout(() => {
        _this.addVideoStepkedian(); //调用插入卡点记录
      }, 1000);
    },

    //调用插入卡点记录
    addVideoStepkedian() {
      let _this = this;
      console.log(_this.presentTiem);
      _this.$refs.videoPlayer.player.currentTime(_this.presentTiem + 2); //插入当前卡点的时间
      _this.$refs.videoPlayer.player.play();
      _this.displayShow = false;
      _this.getstickingPointTime(); //查询下一个卡点的值
    },
    onFail() {
      console.log('验证不通过');
      this.msg = '';
    },
    onRefresh() {
      console.log('点击了刷新小图标');
      this.msg = '';
    },
    onFulfilled() {
      console.log('刷新成功啦！');
    },
    onAgain() {
      console.log('检测到非人为操作的哦！');
      this.msg = 'try again';
      // 刷新
      this.handleClick();
    },
    handleClick() {
      this.$refs.slideblock.reset();
      this.msg = '';
    },
    // 视频的功能-------------------------
    onPlayerPlay(player) {},
    // 视频暂停
    onPlayerPause(player) {},
    // 视频结束事件
    onPlayerEnded(player) {
      this.videoComplete = true;
      console.log(this.$refs.videoPlayer.player.currentTime());
      console.log('结束');
      this.addCourserecord(true); //插入视频记录
      this.serchNexVideo();
    },
    //监听播放器时间
    onPlayerTimeupdate(player) {
      this.gklog = player.currentTime();
      var i = Math.trunc(this.gklog);

      // console.log("视频播放到第" + currentTime + "秒")//查看正在播放时间，以秒为单位  记录快进功能
      if (this.video_real_time == 0) {
        var jump_time =
          parseInt(this.initial_time) + parseInt(this.video_real_time);
      } else {
        var jump_time = parseInt(this.video_real_time);
      }

      if (this.aa == 1) {
        // 是否开启可以视频快进 1 禁止开启
        if (this.gklog > jump_time && this.gklog - jump_time > 3) {
          this.$refs.videoPlayer.player.pause(); //暂停
          if (this.$refs.videoPlayer.player.isFullscreen()) {
            this.$refs.videoPlayer.player.exitFullscreen();
          }
          this.visShow = 5;
          return false;
        }
      }

      this.video_real_time = this.gklog;

      if (this.timeList.length > 0) {
        this.gklog;
        if (i >= this.timeCurent) {
          this.timeList[this.timeIndex].Juge = true;
          if (this.$refs.videoPlayer.player.isFullscreen()) {
            this.$refs.videoPlayer.player.exitFullscreen();
          }

          this.displayShow = true;
          this.$refs.videoPlayer.player.pause();
          this.videoStepId = this.timeList[this.timeIndex].Id;
          this.presentTiem = this.timeList[this.timeIndex].Times;
          return false;
        }
      }
    },

    // 点击快进确定的按钮
    speedclick() {
      console.log(this.video_real_time);
      this.$refs.videoPlayer.player.currentTime(this.video_real_time); //插入当前卡点的时间
      this.$refs.videoPlayer.player.play();
      this.visShow = 100;
    },
    // 查找下一个视频
    serchNexVideo() {
      this.countdown = 5;
      for (let i = Number(this.isActive) + 1; i < this.catalist.length; i++) {
        if (this.catalist[i].type == 1) {
          if (this.catalist[i].id != this.sucontlist.id) {
            this.visShow = 1;
            // this.isActive = i;
            this.nextVideoId = i;
            this.nextVideoAdress = this.catalist[i].filePath;
            this.sendCode();
            return false;
          }
        } else {
          this.visShow = 0;
        }
      }
    },

    // 根据卡点进行操作
    getstickingPointTime() {
      let timeList = this.timeList;
      if (this.findIndexByKeyValue(timeList, 'Juge', false) != -1) {
        //如果还有卡点为1
        this.mark = 1;
      } else {
        this.mark = 0;
      }

      for (let index = 0; index < timeList.length; index++) {
        if (timeList[index].Juge == false) {
          this.timeIndex = index;
          this.timeCurent = timeList[index].Times;
          break;
        } else {
          this.timeCurent = 100000;
        }
      }
    },
    // 查找数组中有没有属性值
    findIndexByKeyValue(arr, key, valuetosearch) {
      for (var i = 0; i < arr.length; i++) {
        // console.log(arr[i][key]);
        if (arr[i][key] == valuetosearch) {
          return i;
        }
      }
      return -1;
    },
    //倒计时
    sendCode() {
      this.loading(); //启动定时器
      this.timer = setInterval(() => {
        //创建定时器
        if (this.countdown === 1) {
          this.clearTimer(); //关闭定时器
          // this.serchNexVideo();
          this.visShow = 0;
          this.isActive = this.nextVideoId;
          this.playCommon(this.nextVideoAdress);
        } else {
          this.loading();
        }
      }, 1000);
    },
    loading() {
      //启动定时器
      this.countdown--; //定时器减1
    },
    clearTimer() {
      //清除定时器
      clearInterval(this.timer);
      this.timer = null;
    },
  },
  // 页面销毁的时候插入记录
  beforeDestroy() {
    if (this.type == 1) {
      if (this.videoComplete == false) {
        this.addCourserecord(false); //插入视频记录
      }
    }
    window.removeEventListener('beforeunload', (e) => this.beforeunloadFn(e));
  },
};
</script>
<style scoped>
.biji:hover {
  background-color: rgb(68, 66, 66);
  color: black;
}
/* 分页 样式*/
.pageblock {
  margin-top: 20px;
  text-align: center;
}
/deep/.el-dialog__header {
  padding: 20px;
  padding-bottom: 10px;
}
.withreview {
  width: 1200px;
  margin: 0 auto;
  margin-top: 20px;
  height: 70px;
  /* border: solid 1px #f2f2f2; */
  padding: 5px 0px;
}
.withreview /deep/.el-form-item__content {
  margin: 0 !important;
}
.withreview /deep/.el-textarea__inner {
  height: 50px !important;
}
</style>
<style lang="scss" scoped>
.learnClass {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 50px 0;
  img {
    width: 87px;
    height: 87px;
  }
}
.centervideo {
  padding-bottom: 50px;
  .chape-right {
    width: 1200px;
    margin: 0 auto;
    .chape-right-header {
      .el-menu {
        display: flex;
        justify-content: space-between;
        border: none;
        padding: 15px 0;

        .el-menu-item {
          height: 30px;
          flex: 1;
          margin-right: 5px;
          border-radius: 5px;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 1px solid rgba(127, 127, 127, 1);
          .el-icon-menu {
            height: 25px;
          }
        }
      }
      .tabul {
        display: flex;
        justify-content: space-around;
        align-items: center;
        height: 34px;
        > li {
          width: 266px;
          background-color: #7f7f7f;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 1px solid rgba(127, 127, 127, 1);
          border-radius: 5px;
          .tabimg {
            width: 25px;
            height: 25px;
          }
          &:hover {
            background-color: #adaaaa46;
          }
        }
        .active {
          background-color: rgba(112, 182, 3, 1);
        }
      }
    }
    .chape-right-center {
      height: 100%;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
    }
  }
}

.commentbox {
  width: 1100px;
  margin: 0 auto;
  padding: 20px 0;

  .commennumber {
    font-weight: bold;
    font-size: 18px;
  }
  .commentaret {
    width: 100%;
    height: 100px;
    border: 1px solid rgba(215, 215, 215, 1);
    border-radius: 3px;
    margin-top: 15px;
    font-size: 16px;
    padding: 5px;
    letter-spacing: 1px;
    &:hover {
      border-color: #409eff;
    }
  }
  .commenbtn {
    display: flex;
    align-items: center;
    margin-top: 10px;
    .commentText {
      flex: 1;
      text-align: right;
      padding-right: 20px;
    }
    .commentbtnst {
      height: 40px;
      width: 100px;
      color: #f7f7f7;
      background-color: #d7d7d7;
      text-align: center;
      line-height: 40px;
      border-radius: 5px;
    }
  }
}
.fottervide {
  margin-top: 20px;
  // background-color: #555555;
  .chape-right-footer {
    width: 1200px;
    margin: 0 auto;
    height: 49px;
    background-color: #555555;
    display: flex;
    justify-content: space-between;
    .browse-left,
    .browse-right {
      display: flex;
      .browsebox {
        display: flex;
        align-items: center;
        margin: 0 20px;
        .browse-img {
          width: 24px;
          height: 24px;
          margin-right: 5px;
          cursor: pointer;
        }
        .browse-text {
          font-size: 14px;
          color: #ffffff;
        }
      }
    }
  }
}

.introducel {
  width: 1200px;
  background-color: rgba(255, 255, 255, 1);
  margin: 0 auto;
  margin-top: 20px;

  .gaishu {
    text-align: justify;
    text-justify: newspaper;
    word-break: break-all;
    border-radius: 5px;
    background-color: rgba(255, 255, 255, 1);
    box-sizing: border-box;
    border: 1px solid rgba(255, 255, 255, 1);
    // box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.349019607843137);
    padding: 10px;
    color: #333333;
    margin-bottom: 20px;
    display: flex;
    border-bottom-color: #e5e9ef;
    &:first-child {
      border-top-color: #e5e9ef;
      padding-top: 30px;
    }
    .gaiimg {
      width: 45px;
      height: 45px;
      border-radius: 50%;
    }
    .gaisuflex {
      flex: 1;
      padding-left: 20px;
      .gaisuname {
        font-size: 16px;
        // font-weight: bold;
      }
      .gaisutext {
        font-size: 16px;
        color: #555;
        padding-top: 10px;
        padding-right: 10px;
        line-height: 22px;
      }
      .giveclbox {
        margin-top: 10px;
        display: flex;
        justify-content: space-between;
        .give-time {
          color: rgba(0, 0, 0, 0.349019607843137);
        }
        .givecl {
          display: flex;
          align-items: center;
          margin-top: 10px;
          background-color: #888;
          height: 30px;
          width: 75px;
          border-radius: 15px;
          justify-content: center;
          color: #fff;
          img {
            height: 15px;
            width: 15px;
            margin-right: 5px;
          }
        }
      }
    }
  }
}

.btnsmint {
  padding: 0 20px;
  background-color: #409eff;
  color: #fff;
  text-align: center;
  border-radius: 3px;
  font-size: 14px;
  display: flex;
  align-items: center;
  margin: 0 10px;
  height: 50px;
}
.tabx {
  height: 540px;
  width: 1200px;
  margin-top: 15px;
  position: relative;
}
.next-box {
  position: absolute;
  z-index: 999;
  border-radius: 20px;
  width: 100%;
  height: 540px;
  color: #fff;
  background-color: rgb(8, 8, 8);
  // line-height: 600px;
  text-align: center;
  border-radius: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.hedvidebox {
  display: flex;
  cursor: pointer;
  height: 30px;
  background-color: #f0f0f0;
  margin-top: 15px;
  img {
    width: 20px;
    height: 20px;
  }
  .hedvide:hover {
    background-color: #00c758;
  }
  .current {
    background-color: #00c758;
  }
}

.centerheader {
  height: 55px;
  background-color: #888;
  display: flex;
  align-items: center;
}
.centerheaderul {
  margin: 0 auto;
  width: 1200px;
  display: flex;
  align-items: center;
  color: #fff;
}

.selcetbox {
  width: 180px;
  height: 30px;
  border-radius: 3px;
}
.centerheaderul label {
  font-size: 20px;
  // font-weight: 700;
}
.arrowspd {
  margin: 0 20px;
}
.txtds {
  width: 1200px;
  margin: 0 auto;
  padding: 40px 0;
  height: 540px;
  overflow: hidden;
  overflow-y: auto;
}
.txtdsbox {
  padding: 10px;
  background-color: #efefef;
  border-radius: 5px;
  font-size: 15px;
  width: 800px;
  margin: 0 auto;
}
.txtds p {
  line-height: 30px;
}

.circleclas {
  height: 80px;
  width: 80px;
  border: 2px solid #3d3d3d;
  border-radius: 50%;
  text-align: center;
  line-height: 80px;
  font-size: 24px;
  margin: 0 auto;
  margin-top: 20px;
}
.replayclas {
  color: #8cb822;
  font-size: 18px;
  margin-top: 20px;
}
.nexpalys {
  font-size: 28px;
}

video::cue(.red) {
  color: red;
}
video::cue(.blue) {
  color: blue;
}
video::cue(.green) {
  color: green;
}
video::cue(.yellow) {
  color: yellow;
}
video::cue(.background-red) {
  background-color: red;
}
video::cue(.background-blue) {
  background-color: blue;
}
video::cue(.background-green) {
  background-color: green;
}
video::cue(.background-yellow) {
  background-color: yellow;
}
video::cue(.font-family-Georgia) {
  font-family: Georgia;
}
video::cue(.font-style-italic) {
  font-style: italic;
}
video::cue(.font-size-60) {
  font-size: 60px;
}
video::cue(.font-size-12) {
  font-size: 40px;
}
video::cue(.text-decoration-underline) {
  text-decoration: underline;
}
video::cue(.text-decoration-underline-color) {
  border-bottom: 3px solid #00f;
  color: #090;
}
video::cue(.text-shadow) {
  font-size: 40px;
  text-shadow: -1px 0 #f00, 0 -1px #f00, 1px 0 #f00, 0 1px #f00;
}
video::cue(.outline) {
  outline: #00ff00 dotted thick;
}
video::cue(.webkit-text-stroke) {
  font-size: 40px;
  -webkit-text-stroke: 2px #ff75bf;
}

.headersts {
  height: 60px;
  width: 100%;
  background-color: rgba(50, 65, 96, 1);
  box-sizing: border-box;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(50, 65, 96, 1);
  border-radius: 0px;
  line-height: 60px;
  font-size: 16px;
  color: #fff;
  font-weight: 600;
}

.imgsts {
  margin-left: 18%;
  width: 40px;
  height: 40px;
  vertical-align: middle;
  cursor: pointer;
}
.Tips {
  position: absolute;
  z-index: 999;
  border-radius: 20px;
  width: 100%;
  height: 100%;
  color: rgb(180, 173, 173);
  background-color: rgb(8, 8, 8);
  line-height: 600px;
  text-align: center;
  border-radius: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.veo-display-show {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 399;
}
/* 视频播放以及拖动弹窗的样式 */
.veo-display {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
}
.sidletext {
  font-size: 14px;
  padding-top: 8px;
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #fff;
}
</style>
<style >
video::cue {
  background: none;
  color: #fff;
  text-shadow: 0 1px #000, 1px 0 #000, -1px 0 #000, 0 -1px #000;
  font-size: 16px;
}

video::cue(b) {
  color: peachpuff;
}
</style>
<style lang="scss">
.dialog-mini {
  .el-dialog__header {
    height: 35px;
    line-height: 35px;
    border-radius: 4px 4px 0 0;
    border-bottom: 1px solid #eee;
    overflow: hidden;
    background-color: #f8f8f8;
    padding: 0 20px;
    .el-dialog__title {
      line-height: 34px;
      font-size: 14px;
      color: #333;
    }
    .el-dialog__headerbtn {
      color: #333;
      top: 11.5px;
      right: 11.5px;
    }
  }
  .el-dialog__footer {
    height: 40px;
    width: 100%;
    text-align: center;
    padding: 0px 10px;
    border-top: 1px solid #eee;
    border-radius: 0 0 4px 4px;
    background-color: #f8f8f8;
    line-height: 40px;
  }
  .el-dialog__body {
    padding: 10px;
    .el-form {
      padding-right: 20px;
      padding-top: 10px;
    }
  }
  .el-form-item__label {
    font-size: 12px;
    font-weight: normal !important;
  }
  .el-form-item.el-form-item--small {
    margin-bottom: 8px;
  }
  .el-form-item.is-error.is-required.el-form-item--small {
    margin-bottom: 18px;
  }
}
</style>
